import script from "./ProductImage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductImage.vue?vue&type=script&setup=true&lang=js"

import "./ProductImage.vue?vue&type=style&index=0&id=50e67be2&scoped=true&lang=css"
import "./ProductImage.vue?vue&type=style&index=1&id=50e67be2&lang=css"

import exportComponent from "/var/www/vhosts/mayesh.com/httpdocs/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50e67be2"]])

export default __exports__